import * as React from 'react'
import { useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { IconButtonSeeker } from 'ui-seeker/core'
import { monthNames } from 'app/@utils/dateLocale'
import { formatPeriod, formatRangesCsv, parseRangesCsv } from 'app/@utils/dayMonthRanges'
import DayMonthRangesModal from './DayMonthRangesModal'
import './DayMonthRangesField.css'

// Form field for the business date (active season(s)) of a compset / setting report: chips with the ranges and a
// button that opens the 12-month calendar. Value = CSV 'MMDD-MMDD,MMDD-MMDD' (null = no business date).
// labelInBorder: label drawn over the top border, like the other form fields (SelectSeeker / TextField).
export default function DayMonthRangesField({ label, value, onChange, modalTitle, hint, emptyLabel, labelInBorder = true }) {
    const { t } = useTranslation('common')
    const [isOpen, setIsOpen] = useState(false)
    const ranges = useMemo(() => parseRangesCsv(value), [value])
    const shortMonths = useMemo(() => monthNames('short'), [])

    return <div className={`day-month-ranges-field ${labelInBorder ? 'label-in-border' : ''}`}>
        {label && <span className="day-month-ranges-field-label">{label}</span>}
        <div className="day-month-ranges-field-box" onClick={() => setIsOpen(true)}>
            {ranges.length ?
                ranges.map((range, index) => <span key={`${range.start}-${range.end}-${index}`} className="day-month-ranges-field-chip">
                    {formatPeriod(range, shortMonths)}
                </span>) :
                <span className="day-month-ranges-field-empty">{emptyLabel || t('common:dayMonthRanges.empty')}</span>
            }
            <IconButtonSeeker icon="calendar-alt" iconType="fontAwesome" size="small" className="day-month-ranges-field-edit" title={t('common:dayMonthRanges.edit')} onClick={() => setIsOpen(true)} />
        </div>

        <DayMonthRangesModal
            isOpen={isOpen}
            controller={setIsOpen}
            title={modalTitle || label}
            ranges={ranges}
            onConfirm={selected => onChange(formatRangesCsv(selected))}
            confirmText={t('common:actions.apply')}
            hint={hint || t('common:dayMonthRanges.hint')}
            selectedLabel={t('common:dayMonthRanges.selected')}
            emptyLabel={emptyLabel || t('common:dayMonthRanges.empty')}
        />
    </div>
}
